// The app's own backend (server/index.js) is reachable at /api on the same
// origin as the static site — Caddy reverse-proxies it there in production
// (see Caddyfile), and the local Parcel dev server does the same locally
// (see .proxyrc.json), both stripping the /api prefix before forwarding so
// the server's own routes stay unprefixed (/register, /setups, ...).
//
// Same-origin on purpose: this used to be a separate DOMAIN:SCAN_SERVER_PORT
// origin, which meant every fetch here was cross-origin — subject to CORS,
// and to mixed-content blocking whenever the page's own protocol didn't
// match what the backend could actually serve (e.g. a locally-run backend,
// which never has TLS, reached from a page loaded over https for unrelated
// reasons). Routing through one origin makes that whole class of bug
// impossible rather than working around it.
export function getServerUrl() {
  return '/api';
}
